const defaultImage = {
    world: "/images/bazaar/world-cover.png",
    system: "/images/bazaar/system-cover.png",
    module: "/images/bazaar/module-cover.png",
    asset: "/images/bazaar/asset-cover.png",
    default: "/images/bazaar.png",
};

/**
 * The names of different elements of the IndexedDB database used for
 * caching Bazaar packages.
 */
const bazaarCachingKeys = {
    /**
     * The IndexedDB database to store cached packages in.
     */
    db: "ForgeBazaar",
    /**
     * The table in the Bazaar package cache DB to store cached packages in.
     *
     * Note that this table is named for the current core version; we don't
     * want different Foundry versions to share the same cached packages.
     *
     * A note for anyone who touches this computed in the future:
     * IndexedDB is *really* picky about table names. They should be
     * alphanumeric, with **no** special characters; no dashes, no underscores.
     * @returns {string} The name to use for the table we cache packages in.
     */
    table: "PackageCache",
    /**
     * The row to store cached packages in.
     */
    row: (coreVersion) => coreVersion.replace(/[\s()]/g, ""),
};

const INDEXEDDB_VERSION_DEFAULT = 1;
const INDEXEDDB_VERSION_BAZAAR = 2;

module.exports = {
    bazaarCachingKeys,
    defaultImage,
    INDEXEDDB_VERSION_DEFAULT,
    INDEXEDDB_VERSION_BAZAAR,
};
